import React from 'react'
import { Text, Flex } from 'theme-ui'
import { ProductInfoProps } from '.'

export default function ProductInfo({ items }: ProductInfoProps): React.ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'left',
        maxWidth: '100rem',
        gap: '4.8rem',
      }}
    >
      {items.map(({ header, subheader, text }) => (
        <Flex
          key={header}
          sx={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
            gap: '1.6rem',
          }}
        >
          {header && (
            <Text
              as="h2"
              sx={{ fontSize: ['2.1rem', '2.8rem'], fontWeight: 600, color: 'aliceBlue' }}
            >
              {header}
            </Text>
          )}
          {subheader && (
            <Text
              sx={{
                fontSize: ['2.1rem', '2.8rem'],
                fontWeight: 600,
                color: 'aliceBlue',
              }}
            >
              {subheader}
            </Text>
          )}
          <Text
            sx={{
              fontSize: '1.8rem',
              fontWeight: 400,
              lineHeight: '138%',
              color: 'lightSteelBlue',
            }}
          >
            {text}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}
